import gql from "graphql-tag"
import { ResponsiveImageFields } from "@dato/DatoContent/fragments"

export const productQuery = gql`
  ${ResponsiveImageFields}

  query productQuery($slug: String!) {
    globalConfiguration {
      shippingMessage
      shippingMessageDisclaimer
      prop65Disclaimer
      prop65Link
    }
    collectionsConfiguration {
      defaultProductCardImage {
        responsiveImage {
          ...ResponsiveImageFields
        }
      }
    }
    product(filter: { slug: { eq: $slug } }) {
      id
      slug
      linkOut {
        ... on BlogRecord {
          __typename
          title
          slug
        }
        ... on GalleryRecord {
          __typename
          title
          slug
        }
        ... on InstallationGuideRecord {
          __typename
          title
          slug
        }
      }
      productName
      productCategory {
        slug
        name
        icon {
          responsiveImage {
            ...ResponsiveImageFields
          }
        }
      }
      productSubcategory {
        name
      }
      proSeriesCategory {
        name
      }
      productStyle {
        name
      }
      tags
      price
      compareAtPrice
      discountedPrice
      isDiscounted
      soldAs
      commonSku
      description
      descriptionFull
      proSeries
      universal
      hasChild
      make {
        name
      }
      model {
        name
      }
      year
      trim {
        name
      }
      thumbnail {
        responsiveImage {
          ...ResponsiveImageFields
        }
      }
      images {
        responsiveImage(imgixParams: { fm: png }) {
          ...ResponsiveImageFields
        }
      }
      embededVideos {
        video {
          url
          thumbnailUrl
        }
      }
      shopifyProducts
      subproductGroups {
        name
        products {
          id
          slug
          productName
          description
          descriptionFull
          price
          compareAtPrice
          discountedPrice
          isDiscounted
          soldAs
          productCategory {
            slug
            name
          }
          productSubcategory {
            name
          }
          make {
            name
          }
          model {
            name
          }
          year
          thumbnail {
            responsiveImage {
              ...ResponsiveImageFields
            }
          }
          images {
            responsiveImage(imgixParams: { fm: png }) {
              ...ResponsiveImageFields
            }
          }
        }
        required
      }
      upsells {
        ... on RelatedProductRecord {
          __typename
          label
          products {
            id
            slug
            productName
            description
            descriptionFull
            soldAs
            productCategory {
              slug
              name
              icon {
                responsiveImage {
                  ...ResponsiveImageFields
                }
              }
            }
            proSeriesCategory {
              name
            }
            productSubcategory {
              name
            }
            make {
              name
            }
            model {
              name
            }
            year
            thumbnail {
              responsiveImage {
                ...ResponsiveImageFields
              }
            }
            images {
              responsiveImage(imgixParams: { fm: png }) {
                ...ResponsiveImageFields
              }
            }
            variants {
              id
              variantName
              variantSku
              price
              compareAtPrice
              discountedPrice
              shopifyData
              options {
                optionValue
                optionType {
                  name
                }
              }
            }
            variantsJson
          }
        }
        ... on UpsellRecord {
          __typename
          label
          productCollection {
            id
            slug
            productName
            description
            descriptionFull
            price
            compareAtPrice
            discountedPrice
            isDiscounted
            soldAs
            productCategory {
              slug
              name
            }
            productSubcategory {
              name
            }
            make {
              name
            }
            model {
              name
            }
            year
            thumbnail {
              responsiveImage {
                ...ResponsiveImageFields
              }
            }
            images {
              responsiveImage(imgixParams: { fm: png }) {
                ...ResponsiveImageFields
              }
            }
          }
          product {
            id
            slug
            productName
            description
            descriptionFull
            price
            compareAtPrice
            discountedPrice
            isDiscounted
            soldAs
            productCategory {
              slug
              name
            }
            proSeriesCategory {
              name
            }
            productSubcategory {
              name
            }
            make {
              name
            }
            model {
              name
            }
            year
            thumbnail {
              responsiveImage {
                ...ResponsiveImageFields
              }
            }
            images {
              responsiveImage(imgixParams: { fm: png }) {
                ...ResponsiveImageFields
              }
            }
          }
          upsellFilter {
            filters {
              label
              options {
                optionValue
                optionType {
                  name
                }
              }
              overridable
            }
          }
        }
      }
      variants {
        id
        variantName
        variantSku
        price
        compareAtPrice
        discountedPrice
        options {
          optionValue
          optionType {
            name
          }
          isColor
          image {
            responsiveImage {
              src
            }
          }
        }
        shopifyData
      }
      variantsJson
    }
  }
`

export const productQueryTrimmed = gql`
  ${ResponsiveImageFields}

  query productQuery($slug: String!) {
    product(filter: { slug: { eq: $slug } }) {
      id
      slug
      productName
      description
      descriptionFull
      price
      compareAtPrice
      discountedPrice
      isDiscounted
      soldAs
      productCategory {
        slug
        name
      }
      proSeriesCategory {
        name
      }
      productSubcategory {
        name
      }
      make {
        name
      }
      model {
        name
      }
      year
      thumbnail {
        responsiveImage {
          ...ResponsiveImageFields
        }
      }
      images {
        responsiveImage(imgixParams: { fm: png }) {
          ...ResponsiveImageFields
        }
      }
    }
  }
`

export const upsellFilter = gql`
  query filterQuery($id: ItemId) {
    upsellFilter(filter: { id: { eq: $id } }) {
      filters {
        label
        options {
          optionValue
          optionType {
            name
          }
        }
        overridable
      }
    }
  }
`
